import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  initialize() {
    // define callbacks used by Cloudflare Turnstile
    window.turnstileSuccess = (e) => {
      let button = document.querySelector('input[type="submit"][data-turnstile-target="submit"]')
      button.disabled = false
      button.classList.remove("disabled")
    }

    window.turnstileError = (e) => {
      let button = document.querySelector('input[type="submit"][data-turnstile-target="submit"]')
      button.disabled = true
      button.classList.add("disabled")
    }
  }
}
